import axios from "axios";
import AlertsApi from "../../../../ui/template/Alert/AlertsApi";
import AppConfig from "../../AppConfig";

const sendLogin = async function (username,password,pageAlerts,formAlerts) {
    let res=false;
    try {
        let query='{login(username:"'+username+'",password:"'+password+'")}';
        let data={  query: query,variables: null, operationName: null  };
        const t = Date.now();
        let url=AppConfig.base_url+`/graphql/auth/member?c=${t}`;
        let config = {
            withCredentials: true,
        };
        let response = await  axios.post(url,data,config);
        if ( response.hasOwnProperty("data")){
            AlertsApi(response.data,pageAlerts,formAlerts);
            if ( response.data.hasOwnProperty("data")) {
                let data = response.data.data;
                if (data.hasOwnProperty("login")) {
                    if (data.login !== "false"){
                        localStorage.setItem('authToken', data.login);
                        res = true;
                    }
                }
            }
        }
    } catch (error) {
        res = false;
    }
    return res;
};

export default async function login(username,password,pageAlerts,formAlerts) {
    return await sendLogin(username,password,pageAlerts,formAlerts);
}
